module.exports = __webpack_public_path__ + "img/img_left_nav_cooperate.51dc40f6.svg";